import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicLinkService } from '../service/dynamic-link.service';

@Pipe({
  name: 'toHtmlElement',
})
export class HtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer, private dynamicLinkService: DynamicLinkService) {}
  //帮助中心将string 转为html
  transform(value: string): any {
    return this.sanitizer.bypassSecurityTrustHtml(this.dynamicLinkService.replaceDomainPlaceholder(value));
  }
}
